import produce from 'immer';
import {
  applyMiddleware,
  combineReducers,
  compose,
  createStore,
  Store,
} from 'redux';
import thunk from 'redux-thunk';

import me, { initialState, MeStoreState } from './me';
import clientListApi from 'store/services/clientListApi';
import { User } from '../types/api/user';

export interface StoreState {
  me: MeStoreState;
}

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// LEGACY CODE
export default function (user: null | User = null): Store {
  const preloadedState = {
    me: produce<MeStoreState>(initialState, (draft) => {
      draft.user = user;
    }),
    notifications: produce<any>(initialState, () => {}),
  };

  return createStore(
    combineReducers({
      [clientListApi.reducerPath]: clientListApi.reducer,
      me,
    }),
    preloadedState,
    composeEnhancers(
      // TODO: issue with typing middlewares
      applyMiddleware(thunk, clientListApi.middleware as any)
    )
  );
}
